/**
 * API client pre vygenerovanú API dokumentáciu (HTML).
 * Backend endpoint: GET /api/V1/docs/:audience/:lang  (za Bearer auth).
 * Vracia HTML ako string – AdminUI ho vloží do <iframe srcdoc>.
 */
import axios from "axios";
import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain, getBEUrl } from "./management";

/**
 * @param {"partner"|"internal"} audience
 * @param {"sk"|"en"} lang
 * @returns {Promise<string>} HTML dokumentácie
 */
export async function getApiDocsHtml(audience, lang) {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(
    `/api/V1/docs/${audience}/${lang}`,
    {
      responseType: "text",
      // zabráni axiosu parsovať HTML ako JSON
      transformResponse: [(d) => d],
    }
  );
  return typeof data === "string" ? data : String(data ?? "");
}

/**
 * Verejná partnerská dokumentácia so ZDIEĽANÝM menom+heslom (mimo systémového loginu).
 * Frontend pošle Basic hlavičku sám (žiadny natívny dialóg pri XHR).
 * Backend: GET /partner-docs/:lang (Basic Auth voči PARTNER_DOCS_USER/PASSWORD).
 *
 * @param {string} user
 * @param {string} pass
 * @param {"sk"|"en"} lang
 * @returns {Promise<string>} HTML dokumentácie
 * @throws {import("axios").AxiosError} 401 pri zlých údajoch
 */
export async function getPartnerDocsPublicHtml(user, pass, lang) {
  const base = getBEUrl().replace(/\/+$/, "");
  const token = btoa(unescape(encodeURIComponent(`${user}:${pass}`)));
  const { data } = await axios.get(`${base}/partner-docs/${lang}`, {
    headers: { Authorization: `Basic ${token}` },
    responseType: "text",
    transformResponse: [(d) => d],
  });
  return typeof data === "string" ? data : String(data ?? "");
}
